<div class="data-container" *ngIf="face">
    <nz-steps [nzCurrent]="currentStep" nzSize="small" class="wizard-steps">
        <nz-step [nzTitle]="'meli.form.step.info'|translateTA" (click)="currentStep=0" class="step-clickable"></nz-step>
        <nz-step [nzTitle]="'meli.form.images'|translateTA" (click)="currentStep=1" class="step-clickable"></nz-step>
        <nz-step [nzTitle]="'meli.form.attributes'|translateTA" (click)="currentStep=2" class="step-clickable"></nz-step>
    </nz-steps>

    <!-- ============ Passo: Informacao Inicial ============ -->
    <div class="step-content" [hidden]="currentStep!==0">
        <form [formGroup]="formVariacao">
            <div class="btn">
                <button nz-button (click)="currentStep=1">{{'meli.form.next'|translateTA}}</button>
                <button nz-button nzType="primary" (click)="finalizar()">{{'meli.variation.finish'|translateTA}}</button>
            </div>
            <div class="field">
                <input-autocomplete
                    [controle]="formVariacao.get('codeproductvar')"
                    [labelName]="'meli.variation.product'|translateTA"
                    entityName="Mktpproducts"
                    [config]="{descColumn:'NAME',keyColumn:'CODEPRODUCT'}"
                    (selectItem)="itemSelect($event)"
                    required="true"
                    (afterLoad)="afterLoad($event,'codeproductvar')">
                </input-autocomplete>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.variation.variationId'|translateTA}}</span>
                    <input nz-input formControlName="idvaricao" type="text" [placeholder]="'meli.variation.variationId'|translateTA" />
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.codLocal'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="codlocalSuffix">
                        <input nz-input formControlName="codlocal" type="text" [placeholder]="'meli.form.codLocal'|translateTA" />
                    </nz-input-group>
                    <ng-template #codlocalSuffix>
                        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchFromProduct'|translateTA"
                            (click)="getDataFromTable(formVariacao,'codlocal',$event, '{@getMeliCodLocalVar}')" />
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('codlocal',formVariacao,$event)" />
                    </ng-template>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.quantity'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="qtdSuffix">
                        <input nz-input formControlName="available_quantity_var" type="number" [placeholder]="'meli.form.quantityPlaceholder'|translateTA" />
                    </nz-input-group>
                    <ng-template #qtdSuffix>
                        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchFromProduct'|translateTA"
                            (click)="getDataFromTable(formVariacao,'available_quantity_var',$event, '{@getMeliSTKVar}')" />
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('available_quantity_var',formVariacao,$event)" />
                    </ng-template>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.percentStock'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="percquantitySuffix">
                        <input nz-input formControlName="percquantity" type="number" [placeholder]="'meli.form.percentStock'|translateTA" />
                    </nz-input-group>
                    <ng-template #percquantitySuffix>
                        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchFromProduct'|translateTA"
                            (click)="getDataFromTable(formVariacao,'percquantity',$event, '{@getMeliPercQuantityVar}')" />
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('percquantity',formVariacao,$event)" />
                    </ng-template>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.variation.priceTable'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="codtabSuffix">
                        <input nz-input formControlName="codtab" type="text" [placeholder]="'meli.variation.priceTable'|translateTA" />
                    </nz-input-group>
                    <ng-template #codtabSuffix>
                        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchFromProduct'|translateTA"
                            (click)="getDataFromTable(formVariacao,'codtab',$event, '{@getMeliCodTabVar}')" />
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('codtab',formVariacao,$event)" />
                    </ng-template>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.price'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="priceSuffix">
                        <input nz-input formControlName="pricevar" type="number" [placeholder]="'meli.form.price'|translateTA" />
                    </nz-input-group>
                    <ng-template #priceSuffix>
                        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchPrice'|translateTA"
                            (click)="getDataFromTable(formVariacao,'pricevar',$event, '{@getMeliPrice}')" />
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('pricevar',formVariacao,$event)" />
                    </ng-template>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.percentIncrease'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="percacresSuffix">
                        <input nz-input formControlName="percacres" type="number" [placeholder]="'meli.form.percentIncrease'|translateTA" />
                    </nz-input-group>
                    <ng-template #percacresSuffix>
                        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchFromProduct'|translateTA"
                            (click)="getDataFromTable(formVariacao,'percacres',$event, '{@getMeliPercAcrescVar}')" />
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('percacres',formVariacao,$event)" />
                    </ng-template>
                </div>

                <div class="tem-field">
                    <span class="tem-field-label">{{'meli.form.percentDiscount'|translateTA}}</span>
                    <nz-input-group [nzSuffix]="percdescontoSuffix">
                        <input nz-input formControlName="percdesconto" type="number" [placeholder]="'meli.form.percentDiscount'|translateTA" />
                    </nz-input-group>
                    <ng-template #percdescontoSuffix>
                        <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchFromProduct'|translateTA"
                            (click)="getDataFromTable(formVariacao,'percdesconto',$event, '{@getMeliPercDescontoVar}')" />
                        <nz-icon nzType="close-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA"
                            (click)="clear('percdesconto',formVariacao,$event)" />
                    </ng-template>
                </div>
            </div>
        </form>
    </div>

    <!-- ============ Passo: Imagens ============ -->
    <div class="step-content" [hidden]="currentStep!==1">
        <div class="btn">
            <button nz-button (click)="currentStep=0">{{'meli.form.back'|translateTA}}</button>
            <button nz-button (click)="currentStep=2">{{'meli.form.next'|translateTA}}</button>
            <button nz-button nzType="primary" (click)="finalizar()">{{'meli.variation.finish'|translateTA}}</button>
        </div>
        <div class="field">
            <div class="tem-field">
                <span class="tem-field-label">{{'meli.form.images'|translateTA}}</span>
                <div class="image-tags" *ngIf="images.length > 0">
                    <nz-tag *ngFor="let image of images" nzMode="closeable" (nzOnClose)="remove(image)" nz-tooltip [nzTooltipTitle]="image">
                        {{image}}
                    </nz-tag>
                </div>
                <nz-input-group [nzSuffix]="imageSuffix">
                    <input nz-input #imageInput [formControl]="imageCtrl" [placeholder]="'meli.form.newImage'|translateTA" (keydown.enter)="add(); $event.preventDefault()" />
                </nz-input-group>
                <ng-template #imageSuffix>
                    <nz-icon nzType="plus-circle" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.addImage'|translateTA"
                        (click)="add()" />
                    <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.form.fetchImages'|translateTA"
                        (click)="getDataFromTable('images',null,$event, '{@getImagesVarMeli}', true)" />
                </ng-template>
            </div>
        </div>
    </div>

    <!-- ============ Passo: Atributos ============ -->
    <div class="step-content" [hidden]="currentStep!==2">
        <div class="btn">
            <button nz-button (click)="currentStep=1">{{'meli.form.back'|translateTA}}</button>
            <button nz-button nzType="primary" (click)="finalizar()">{{'meli.variation.finish'|translateTA}}</button>
        </div>
        <div class="field">
            <div class="atributo-garantia">
                <ngx-spinner bdColor="rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()" size="medium" color="#fff" type="ball-clip-rotate-multiple" [fullScreen]="false" name='meliitemcontainervariacao'>
                </ngx-spinner>
                <div class="links">
                    <button nz-button nzType="link" (click)="buscarAtributosVar()">{{'meli.form.fetchAttributes'|translateTA}}</button>
                </div>

                <nz-collapse>
                    <nz-collapse-panel [nzHeader]="'meli.form.attributes'|translateTA" [nzExtra]="attribExtra">
                        <ng-template #attribExtra>
                            <span class="attrib-extra">{{'meli.variation.productAttributes'|translateTA}} <nz-icon nzType="tags" /></span>
                        </ng-template>
                        <div class="attrib-grid">
                            <ng-container *ngFor="let atrib of selectedData['attribs']; let i = index"
                                [ngTemplateOutlet]="main" [ngTemplateOutletContext]="{$implicit:atrib, type:'A', index:i}"></ng-container>
                        </div>
                    </nz-collapse-panel>
                </nz-collapse>
            </div>
        </div>
    </div>
</div>

<!-- ============ Card de atributo ============ -->
<ng-template #main let-item let-type="type" let-index="index">
    <div class="attrib-card" [class.attrib-card-required]="isRequired(item,type)">
        <div class="attrib-card-header">
            <span class="attrib-card-title" nz-tooltip [nzTooltipTitle]="item.name == null ? item.descratrib : item.name">
                {{item.name == null ? item.descratrib : item.name}}
            </span>
            <nz-icon nzType="close" class="attrib-card-close" *ngIf="!isRequired(item,type)"
                (click)="deleteItem(item,type,index,$event)" />
        </div>
        <div class="attrib-card-hint" nz-tooltip [nzTooltipTitle]="item.hint">{{item.hint}}</div>

        <div class="attrib-card-content">
            <!-- Texto -->
            <nz-input-group [nzSuffix]="attribSuffix" *ngIf="item.value_type=='string' || item.value_type==null">
                <input nz-input type="text" [maxLength]="item.value_max_length == null? 500 : item.value_max_length"
                    [(ngModel)]="item.value_id" [required]="isRequired(item,type)"
                    [CustomValidatorDirective]="attribValidator"
                    [placeholder]="item.name == null ? item.descratrib : item.name" />
            </nz-input-group>

            <!-- Numero + unidade -->
            <div *ngIf="item.value_type=='number_unit'" class="multi-field">
                <input nz-input type="number" class="left" [maxLength]="item.value_max_length == null? 500 : item.value_max_length"
                    [(ngModel)]="item.value_id" [required]="isRequired(item,type)" [CustomValidatorDirective]="attribValidator"
                    [placeholder]="item.name == null ? item.descratrib : item.name" />
                <nz-select class="right" [(ngModel)]="item.value_unit" [required]="isRequired(item,type)"
                    [CustomValidatorDirective]="attribValidator" nzAllowClear
                    [nzPlaceHolder]="'meli.form.unit'|translateTA">
                    <nz-option [nzValue]="option.id" [nzLabel]="option.name" *ngFor="let option of item.allowed_units"></nz-option>
                </nz-select>
            </div>

            <!-- Numero -->
            <input nz-input type="number" *ngIf="item.value_type=='number'" class="full"
                [maxLength]="item.value_max_length" [(ngModel)]="item.value_id" [required]="isRequired(item,type)"
                [CustomValidatorDirective]="attribValidator"
                [placeholder]="item.name == null ? item.descratrib : item.name" />

            <!-- Lista/boolean/string com opcoes -->
            <nz-select *ngIf="(item.value_type=='boolean' || item.value_type=='list' || ( item.value_type == 'string' && item.values != null ) )"
                [(ngModel)]="item.value_id" [required]="isRequired(item,type)" [CustomValidatorDirective]="attribValidator"
                nzShowSearch nzAllowClear class="full"
                [nzPlaceHolder]="item.name == null ? item.descratrib : item.name">
                <nz-option [nzValue]="option.id" [nzLabel]="option.name" *ngFor="let option of item.values"></nz-option>
            </nz-select>

            <ng-template #attribSuffix>
                <nz-icon nzType="rollback" class="field-action" nz-tooltip [nzTooltipTitle]="'meli.variation.fetchInfo'|translateTA"
                    (click)="openDataOption(item)" />
            </ng-template>
        </div>
    </div>
</ng-template>

<!-- ============ Lista de variacoes ============ -->
<div class="data-container" *ngIf="!face">
    <div class="variation-grid">
        <div class="variation-card" *ngFor="let variacao of variacoes; let i = index" (click)="selectItem(variacao,i)">
            <div class="variation-card-header">
                <span class="variation-card-title">
                    {{variacao.codeproductvar}} - {{variacao['fk_mktpmeliskuvar_2_mktpproducts->name']}}
                </span>
                <nz-icon nzType="close" class="variation-card-close" (click)="deleteItem(variacao,'V',i,$event)" />
            </div>
        </div>
        <div *ngIf="variacoes.length == 0" class="no-variation">
            {{'meli.variation.noVariations'|translateTA}}
        </div>
    </div>
</div>
